import url from 'url'
import { loadScript } from 'shared/dom'

export default class FacebookSDK {

  constructor (config) {
    this.FB = this._initScript(config)
  }

  async _initScript ({ appId, siteDomain, version, src = '//connect.facebook.net/en_US/sdk.js' }) {
    await loadScript(src)

    window.FB.init({
      appId: appId,
      channelUrl: url.resolve(siteDomain, '/public/html/channel.html'),
      status: true,
      cookie: true,
      xfbml: true,
      version: `v${version}`,
    })
    return window.FB
  }

  /**
   * Promisify Facebook's getLoginStatus method
   * @return {Promise}
   */
  async getLoginStatus () {
    await this.FB
    return new Promise((resolve) => window.FB.getLoginStatus(resolve))
  }

  /**
   * Promisify Facebook's login method
   * @return {Promise}
   */
  async login () {
    await this.FB
    const permissions = 'public_profile,email,user_birthday'

    return new Promise((resolve, reject) => {
      window.FB.login((response) => {
        if (response.authResponse) {
          resolve(response)
        } else {
          reject(response)
        }
      }, {
        scope: permissions,
      })
    })
  }

  /**
   * Promisify Facebook's logout method
   * @return {Promise}
   */
  async logout () {
    await this.FB

    return new Promise((resolve, reject) => {
      window.FB.logout((response) => {
        if (response.authResponse) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  }

  async getSelf (token) {
    await this.FB
    const permissions = 'email,birthday,first_name,last_name,gender'

    return new Promise((resolve, reject) => {
      window.FB.api('/me', 'GET', {
        access_token: token,
        fields: permissions,
      }, (response) => {
        if (!response || response.error) {
          reject(response)
        } else {
          resolve(response)
        }
      })
    })
  }

  async postToFacebook (params) {
    await this.FB
    return new Promise((resolve, reject) => {
      window.FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          window.FB.ui(params)
          resolve()
        } else {
          window.FB.login((loginResponse) => {
            if (loginResponse.authResponse) {
              window.FB.ui(params)
              resolve()
            } else {
              reject()
            }
          })
        }
      })
    })
  }

}
